import { AsyncComponent } from '@twigeducation/async-component';
import { WithAuthentication } from '@twigeducation/oidc-client-react';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { FeatureFlag } from '@twigeducation/unleash-client-react';
import { SpeechStream } from '@twigeducation/speechstream';
import Layout from '../../layout';
import withProductSubscriptions from '../../components/withProductSubscriptions';
import digitalGlossaryUrl from './urls';
import getUser from '../../helpers/getUser';
import NotFound from '../NotFound';
import AsyncComponentError from '../../components/AsyncComponentError';

const DigitalGlossary = withProductSubscriptions(props => (
    <FeatureFlag
        key="digital-glossary"
        flagKey="digital-glossary"
        renderFeatureCallback={() => (
            <AsyncComponent
                appName="ms-digital-glossary-mfe"
                componentName="DigitalGlossary"
                errorComponent={AsyncComponentError}
                {...props}
            />
        )}
        renderDefaultCallback={() => <NotFound />}
    />
));
const SpeechStreamWithStartingPoints = props => {
    const { language } = props;
    const user = getUser();
    const userRole = user.role;
    const isStudent = userRole === 'STUDENT';

    const contentLanguage = language || 'en-US';
    const languageCode = isStudent ? contentLanguage : 'en-US';

    useEffect(() => {
        const previousLang = document.documentElement.lang;
        document.documentElement.setAttribute('lang', contentLanguage);
        return () => {
            if (previousLang) {
                document.documentElement.setAttribute('lang', previousLang);
            } else {
                document.documentElement.removeAttribute('lang');
            }
        };
    }, [contentLanguage]);

    return (
        <SpeechStream
            {...props}
            languageCode={languageCode}
            startingPoints={['termModalBody']}
            autoPlay
            showFixedToolbar
            fillColor="#0D729A"
        />
    );
};

SpeechStreamWithStartingPoints.propTypes = {
    language: PropTypes.string,
};

SpeechStreamWithStartingPoints.defaultProps = {
    language: 'en-US',
};

const allowedRoles = ['TEACHER', 'STUDENT', 'SCHOOL_ADMIN', 'DISTRICT_OWNER', 'TWIGADMIN'];

const routes = [
    <Route path={`${digitalGlossaryUrl}*`} key="digital-glossary">
        <WithAuthentication roles={allowedRoles}>
            <DigitalGlossary Layout={Layout} SpeechStream={SpeechStreamWithStartingPoints} />
        </WithAuthentication>
    </Route>,
];
export default routes;
